import React from "react";
import { Divider, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TemperaturesSection from "./TemperaturesSection";
import ProductionSheets from "./ProductionSheets";
import { useTranslation } from "react-i18next";
import { TCategoryProductSheet } from "../../types/product";

export interface IFormTemperatures {
  name: string;
  isRequired: boolean;
  setIsRequired: any;
  temperatures: any;
  setTemperatures: any;
  errorValidations?: any;
  setErrors?: any;
  type: any;
}

interface HoldingProfileFormProps {
  region?: string;
  formProfiles: any;
  productSheet: TCategoryProductSheet;
  setProductSheet: (productSheet: TCategoryProductSheet) => void;
}

export function HoldingProfileForm({
  region,
  formProfiles,
  productSheet,
  setProductSheet,
}: HoldingProfileFormProps) {
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <ProductionSheets
          region={region}
          productSheet={productSheet}
          setProductSheet={setProductSheet}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography style={{ fontSize: 14 , fontWeight: 600}} align="center">
          {t('holdingProfile.minMaxTemperatures')}
        </Typography>
      </Grid>
    {formProfiles?.map((profile: IFormTemperatures, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12}>
          <TemperaturesSection {...profile} />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 15, marginTop: 10 }}>
          <Divider />
        </Grid>
      </React.Fragment>
    ))}
    </>
  );
}
